<label class="input-with-spinner">
  <span *ngIf="label" libLabel>{{ label }}</span>

  <ng-content></ng-content>

  <div class="loading-spinner" [ngClass]="{ 'top-spacing': useCustomSpacing }" *ngIf="isLoading">
    <mat-spinner [diameter]="diameter"></mat-spinner>
  </div>
</label>
